(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("styled-components"), require("@ls/react-modal"), require("@ls/react-button"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "styled-components", "@ls/react-modal", "@ls/react-button"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("styled-components"), require("@ls/react-modal"), require("@ls/react-button")) : factory(root["react"], root["styled-components"], root["@ls/react-modal"], root["@ls/react-button"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__3__) {
return 